module.exports = __webpack_public_path__ + "static/media/CHAP01-OUVERTURE.6f011e4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skew/img/CHAP01-OUVERTURE.png
// module id = 294
// module chunks = 0